import { DashboardModule, Form } from '@domain-group/suit-theme'

import { deepSetObject } from '@domain-group/javascript-utils'

import { useUserForm } from '@hooks/useUser'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import type { AgencyModel } from '@models/types'

import RealbaseId from './RealbaseId'

interface AdvancedProps {
  agency: AgencyModel,
  userForm: ReturnType <typeof useUserForm>,
}

const Advanced = (props: AdvancedProps) => {
  const { agency, userForm } = props

  const {
    entityState: {
      data,
      data: { api_client_id, slack_member_id },
    },
    handlers,
    setEntityState,
  } = userForm

  return (
    <DashboardModule title="Advanced">
      <Form padding="large">
        <Form.Row>
          <Form.Field label="Slack Member ID">
            <input name="data.slack_member_id" type="text" value={slack_member_id} {...handlers} />
          </Form.Field>

          {/*
           // @ts-expect-error TS2322 */}
          <Form.Field label="API Client ID" marginTop={['large', 0]}>
            <input name="data.api_client_id" type="text" value={api_client_id} {...handlers} />
          </Form.Field>
        </Form.Row>

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <Form.Row>
            <Form.Field label="Realbase ID" marginTop="large">
              <RealbaseId
                agency={agency}
                callbacks={{
                  // @ts-expect-error TS2345
                  selectItem: id => setEntityState({ data: deepSetObject(data, 'external_ids.realbase', id) }),
                }}
                userForm={userForm}
              />
            </Form.Field>
          </Form.Row>
        </ScopedConditionalContent>
      </Form>
    </DashboardModule>
  )
}

export default Advanced
